import styles from './StatsBar.module.scss';
import { useSelector } from 'react-redux';
import { selectScenarioFourStats } from 'selectors/selectors';
import {
    checkNullReturnZero,
    formatNumber2DPStringIfNotZeroOrHundred,
    numberFormat
} from 'utils/common';

const ScenarioFourStats = () => {
    const scenarioFourStats = useSelector(selectScenarioFourStats);
    const { maxClient, instrumentTypeCount, totalOutliers, percentOutliers } = {
        ...scenarioFourStats
    };
    return (
        <>
            <div className={styles.stat}>
                <div className={styles.value}>
                    <div className={styles.main}>
                        {maxClient === null
                            ? '-'
                            : `${numberFormat(maxClient, true)} : 1`}
                    </div>
                </div>
                <div className={styles.description}>Max Client: Product</div>
            </div>
            <div className={styles.stat}>
                <div className={styles.value}>
                    <div className={styles.main}>
                        {checkNullReturnZero(
                            numberFormat(instrumentTypeCount, true)
                        )}
                    </div>
                </div>
                <div className={styles.description}>Instrument Type</div>
            </div>
            <div className={styles.stat}>
                <div className={styles.value}>
                    <div className={styles.main}>
                        {checkNullReturnZero(numberFormat(totalOutliers, true))}
                    </div>
                    <div className={styles.percentage}>
                        {formatNumber2DPStringIfNotZeroOrHundred(
                            percentOutliers
                        )}
                    </div>
                </div>
                <div className={styles.description}>S4 Outliers</div>
            </div>
        </>
    );
};

export default ScenarioFourStats;
